module.exports = __webpack_public_path__ + "static/media/27.455c1366.jpg";